import { breakpoints } from './utils/breakpoints';

class Highlights {
    constructor() {
        this.class = {
            module: '.module-highlights',
            accordionCollapse: '.accordion-collapse',
        };

        this.init = this.init.bind(this);
        this.onResize = this.onResize.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init, false);
        } else {
            this.init();
        }
    }

    init() {
        this.updateAccordionBehavior();
        window.addEventListener('resize', this.onResize);
    }

    onResize() {
        this.updateAccordionBehavior();
    }

    updateAccordionBehavior() {
        const isMobile = window.innerWidth < breakpoints.xl;

        document.querySelectorAll(this.class.module).forEach(module => {
            const collapses = module.querySelectorAll(this.class.accordionCollapse);

            if (collapses.length === 0) {
                return;
            }

            collapses.forEach(collapse => {
                if (isMobile) {
                    collapse.removeAttribute('data-bs-parent');
                } else {
                    const accordionId = collapse.closest('.accordion').id;
                    collapse.setAttribute('data-bs-parent', `#${accordionId}`);
                }
            });
        });
    }
}

export default new Highlights();
